// Copyright (c) 2017 TrainHeroic LLC
// Actions for Designer view

export default {
    BLOCK_ADD: 'designer-block-add',
    BLOCK_ADD_EXERCISE: 'designer-block-add-exercise',
    BLOCK_DELETE: 'designer-block-delete',
    BLOCK_SWAP_EXERCISE: 'designer-block-swap-exercise',
    BLOCK_SYNC_ORDER: 'designer-block-sync-order',
    BLOCK_UPDATE: 'designer-block-update',
    BLOCK_UPDATE_ID: 'designer-block-update-id',
    BLOCK_UPDATE_EXERCISE: 'designer-block-update-exercise',
    BLOCK_UPDATE_EXERCISE_IDS: 'designer-block0-update-exercise-ids',
    DESIGNER_SET_INFO: 'designer-set-info',
    EXERCISES_BENCHMARK_REF_ADD: 'designer-exercise-benchmark-ref-add',
    EXERCISES_REF_ADD: 'designer-exercise-ref-add',
    EXERCISE_UPDATE: 'exercise-update',
    UI_PAGE_TITLE: 'designer-ui-page-title',
    SESSION_ADD: 'designer-session-add',
    SESSION_DELETE: 'designer-session-delete',
    SESSION_UPDATE: 'designer-session-update',
    LIBRARY_SESSION_ADD: 'library-session-add',
    SET_CURRENT_DAY: 'designer-set-current-day',
    SET_EXERCISE_DELETE: 'designer-set-exercise-delete',
    SET_CURRENT_BLOCK: 'set-current-block',
    SET_SELECTED_DATE: 'designer-set-selected-date',
    SET_HOVER_DATE: 'designer-set-hover-date,',
    SCHEME_ADD: 'designer-scheme-add',
    SCHEME_UPDATE: 'designer-scheme-update',
    UI_DELETE_DIALOG: 'designer-ui-delete-dialog',
    UI_SAVING: 'designer-ui-saving',
    UI_SCHEME_DIALOG: 'designer-ui-scheme-dialog',
    UI_BLOCK_EDITING: 'designer-ui-block-editing',
    UI_BLOCK_LINKING: 'designer-ui-block-linking',
    UI_BLOCK_SAVED: 'designer-ui-block-saved',
    UI_BLOCK_SAVING: 'calendar-ui-block-saving',
    UI_CIRCUIT_DIALOG: 'designer-ui-circuit-dialog',
    UI_COMBO_EDIT_DIALOG: 'designer-ui-combo-edit-dialog',
    UI_CONFIRM_DIALOG: 'designer-ui-confirm-dialog',
    UI_SUPERSET_SAVE_DIALOG: 'designer-ui-superset-save-dialog',
    UI_SAVE_SESSION_TO_LIBRARY_DIALOG:
        'calendar-ui-save-session-to-library-dialog',
    UI_ENABLE_CIRCUIT_SAVE: 'designer-ui-enable-circuit-save',
    UI_BLOCK_FOCUS: 'designer-ui-block-focus',
    UI_MEGADROP_OPEN: 'designer-ui-megadrop-open',
    UI_MORE_VIDEOS: 'designer-ui-more-videos',
    UI_NEW_DIALOG: 'designer-ui-new-dialog',
    UI_CREATE_TAG: 'designer-ui-create-tag',
    UPDATE_SCHEME_COUNT: 'designer-update-scheme-count'
};



// WEBPACK FOOTER //
// ./src/state/reducer/designer/actions.js